import Modal from "@/components/Modal";
import {getInstance} from "@/app";

import "./style.css";

export default class RegisterInterestModal extends Modal {
  static selector = ".register-interest-modal";

  constructor(block) {
    super(block);

    this.block = block;

    this.subtitle = this.block.querySelector('.modal__subtitle');

    this.currentPage = 0;
    this.pages = [...this.block.querySelectorAll('.register-interest-form__step')];

    this.pagers = [...this.block.querySelectorAll('.modal__pager')];

    this.btnBack = this.block.querySelector('.btn_back');
    this.btnNext = this.block.querySelector('.btn_next');
    this.form = this.block.querySelector('form');

    this.closeThankYouButton = this.block.querySelector('.modal__dialog--thank-you .modal__close');

    this.closeThankYouButton.addEventListener("click", this.close);
  }

  // Lifecycle methods
  onReady() {
    if(this.btnBack) {
      this.btnBack.addEventListener('click', this.onBack);
    }
    if(this.btnNext) {
      this.btnNext.addEventListener('click', this.onNext);
    }
    if(this.form) {
      this.form.addEventListener('formValidated', this.updateStep);
    }
  }

  onComplete() {
      this.formInstance = getInstance(this.block.querySelector('.register-interest-form'));
      this.updateStep();    
  }

  modalDidMount = async () => {};
  modalWillOpen = async () => {};
  modalDidUpdate = async ({ whatever }) => {};
  modalDidClose = async () => {
    this.block.classList.remove("thank-you");
    this.btnNext.classList.remove('button--success');
    this.currentPage = 0;
    this.hasToScrollTop = true;
    this.updateStep();
  };
  onDestroy() {
    if(this.btnBack) {
      this.btnBack.removeEventListener('click', this.onBack);
    }
    if(this.btnNext) {
      this.btnNext.removeEventListener('click', this.onNext);
    }    
    if(this.form) {
      this.form.removeEventListener('formValidated', this.updateStep);
    }
  }

  onBack = () => {
    if(this.currentPage > 0) {
      this.currentPage--;
      this.hasToScrollTop = true;
      this.updateStep();
    }
  }

  onNext = () => {
    if(this.btnNext.classList.contains('btn--disabled')) {
      this.formInstance.form.validate();
    } else if(this.currentPage < (this.pages.length - 1) ) {
      this.currentPage++;
      this.hasToScrollTop = true;
      this.updateStep();
    } else {
      this.formInstance.form.form.addEventListener('submitsent', this.onSubmitSent);
      this.formInstance.form.form.addEventListener('submitsucceeded', this.onSubmitSucceded);
      this.formInstance.form.form.addEventListener('submitfailed', this.onSubmitFailed);

      this.formInstance.form.submitButton.click();
      //get events for sending and for results
    }
  }

  onSubmitSent = () => {
    this.formInstance.form.form.removeEventListener('submitsent', this.onSubmitSent);
    this.btnNext.innerText = 'Sending...';
    this.btnNext.classList.add("button--loading");
  }

  onSubmitSucceded = () => {
    this.formInstance.form.form.removeEventListener('submitsucceeded', this.onSubmitSucceded);
    this.formInstance.form.form.removeEventListener('submitfailed', this.onSubmitFailed);
    this.btnNext.innerText = 'Sent';
    this.btnNext.classList.remove("button--loading");
    this.btnNext.classList.add('button--success');
    this.block.classList.add("thank-you");
  }

  onSubmitFailed = () => {
    this.formInstance.form.form.removeEventListener('submitsucceeded', this.onSubmitSucceded);
    this.formInstance.form.form.removeEventListener('submitfailed', this.onSubmitFailed);
    this.btnNext.innerText = 'Send';
    this.btnNext.classList.remove("button--loading");
    this.btnNext.classList.remove('button--success');
  }

  updateStep = () => {
    const valid = this.formInstance.form.isValid(this.currentPage);
    this.pages.forEach(p => {
      if(p.dataset.index == this.currentPage) {
        p.classList.add('register-interest-form__step--active');
        if(this.hasToScrollTop) {
          this.block.querySelector('.modal__dialog').scrollTop = 0;
          this.hasToScrollTop = false;
        }
      } else {
        p.classList.remove('register-interest-form__step--active');
      }
    });
    if(this.currentPage > 0) {
      this.block.classList.add('show-header');
    } else {
      this.block.classList.remove('show-header');
    }
    this.pagers.forEach(pager => {
      const pages = [...pager.querySelectorAll('li')];
      pages.forEach((page, index) => {
        if(index < this.currentPage) {
          page.classList.remove('current');
          page.classList.add('done');
        } else if(index === this.currentPage) {
          page.classList.remove('done');
          page.classList.add('current');
        } else {
          page.classList.remove('done');
          page.classList.remove('current');          
        }
      });
    })
    if(this.currentPage > 0) {
      this.btnBack.classList.remove('btn--disabled');
    } else {
      this.btnBack.classList.add('btn--disabled');
    }
    if(this.currentPage < this.pages.length) {
      this.btnNext.innerText = this.currentPage == (this.pages.length - 1) ? 'Send' : 'Next';
      if(valid) {
        this.btnNext.classList.remove('btn--disabled');  
      } else {
        this.btnNext.classList.add('btn--disabled');
      }
    } else {
      this.btnNext.classList.add('btn--disabled');
    }
  }
}
